import React from 'react'
import styled from '@emotion/styled'

import { breakpoints } from '../styles/variables'

const StyledPhilosophyRelatedList = styled.div`
  font-size: var(--font-size-l2);

  @media (min-width: ${breakpoints.tablet}px) {
    margin-left: auto;
    margin-right: auto;
    width: 50%;
  }
`

export const PhilosophyRelatedList: React.FC = ({ children }) => (
  <StyledPhilosophyRelatedList>{children}</StyledPhilosophyRelatedList>
)
